export default "__VITE_ASSET__DyJ3KZ$b__"